<div class="country-selector" :class="containerClasses" @click.stop>

    <div class="country-selector_select">
        <span v-if="withFlags" class="country-flag" :class="inputFlagIcon"></span>
        <input
            ref="countrySelectInput"
            class="country-selector_input"
            type="text"
            :placeholder="placeholder"
            autocomplete="off"
            v-model="filter"
            @focus="onFocus"
            @keydown.down.up.prevent="onKeyDown"
            @keydown.esc="onEsc"
            @keydown.enter="select()"
            :data-at-role="qaDataAttributes.input || 'input-country'"/>

        <span class="country-selector_arrow-bar">
            <span class="country-selector_arrow" @click="toggleState"></span>
        </span>

        <select class="country-selector_touch" @change="onSelectChange">
            <option
                v-for="option in options"
                :key="`touch__${option.value}`"
                v-text="option.text"
                :value="option.value"></option>
        </select>
    </div>

    <div class="dropdown-menu" ref="countrySelectDropdown">
        <ul>
            <template v-if="filteredOptions.length">
                <li
                    v-for="(option, index) in filteredOptions"
                    :key="option.value"
                    class="dropdown-menu_item"
                    :class="{'dropdown-menu_item__active': index === highlightedOptionIndex}"
                    @click.stop="select(option)">
                    <span class="dropdown-menu_link">
                        <span
                            v-if="withFlags"
                            class="country-flag"
                            :class="`country-flag__${option.value.toLowerCase()}`"></span>
                        {{ option.text }}
                    </span>
                </li>
            </template>
            <li v-else class="dropdown-menu_item">
                <span class="dropdown-menu_link" v-text="noResultsMessage"></span>
            </li>
        </ul>
    </div>
</div>
